function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_18198",
  "data-name": "Group 18198",
  transform: "translate(-7.43 -0.075)"
}, React.createElement("path", {
  id: "Path_4526",
  "data-name": "Path 4526",
  d: "M12.238,16.746,8,17.507a.436.436,0,0,1-.544-.544Zm.87-.87L9.084,11.851,19.527,1.408l4.025,4.025Zm11.2-11.2L20.288.646a2.173,2.173,0,0,1,2.937,0l1.088,1.088A1.978,1.978,0,0,1,24.313,4.671Z",
  transform: "translate(0 0)"
}), React.createElement("rect", {
  id: "Rectangle_6664",
  "data-name": "Rectangle 6664",
  width: 14.685,
  height: 5.765,
  transform: "translate(9.072 11.794) rotate(-45)"
}), React.createElement("path", {
  id: "Path_4527",
  "data-name": "Path 4527",
  d: "M21.137.646a2.173,2.173,0,0,0-2.937,0l4.025,4.025a2.173,2.173,0,0,0,0-2.937Z",
  transform: "translate(2.088 0)"
}), React.createElement("path", {
  id: "Path_4529",
  "data-name": "Path 4529",
  d: "M6.946,16.486l4.242-.761L7.163,11.7,6.4,15.942A.436.436,0,0,0,6.946,16.486Z",
  transform: "translate(1.05 1.021)"
}));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 17.535,
    height: 17.454,
    viewBox: "0 0 17.535 17.454",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Edit.0f7dad2b.svg";
export { ForwardRef as ReactComponent };